'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var PeerId = require('peer-id');

var _require = require('./rpc'),
    RPC = _require.RPC;

var _require2 = require('uint8arrays/concat'),
    uint8ArrayConcat = _require2.concat;

var _require3 = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require3.fromString;

var SignPrefix = uint8ArrayFromString('libp2p-pubsub:');

var _require4 = require('../utils'),
    normalizeOutRpcMessage = _require4.normalizeOutRpcMessage;
/**
 * @typedef {import('..').InMessage}
 */

/**
 * Signs the provided message with the given `peerId`
 *
 * @param {PeerId} peerId
 * @param {InMessage} message
 * @returns {Promise<InMessage>}
 */


function signMessage(_x, _x2) {
  return _signMessage.apply(this, arguments);
}
/**
 * Verifies the signature of the given message
 *
 * @param {InMessage} message
 * @returns {Promise<boolean>}
 */


function _signMessage() {
  _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, message) {
    var bytes, signature;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Get the message in bytes, and prepend with the pubsub prefix
            bytes = uint8ArrayConcat([SignPrefix, RPC.Message.encode(normalizeOutRpcMessage(message)).finish()]);
            _context.next = 3;
            return peerId.privKey.sign(bytes);

          case 3:
            signature = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, message), {}, {
              signature: signature,
              key: peerId.pubKey.bytes
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _signMessage.apply(this, arguments);
}

function verifySignature(_x3) {
  return _verifySignature.apply(this, arguments);
}
/**
 * Returns the PublicKey associated with the given message.
 * If no, valid PublicKey can be retrieved an error will be returned.
 *
 * @param {InMessage} message
 * @returns {Promise<PublicKey>}
 */


function _verifySignature() {
  _verifySignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(message) {
    var bytes, pubKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (message.signature) {
              _context2.next = 2;
              break;
            }

            throw new Error('Message must contain a signature to be verified');

          case 2:
            if (message.from) {
              _context2.next = 4;
              break;
            }

            throw new Error('Message must contain a from property to be verified');

          case 4:
            // Get message sans the signature
            bytes = uint8ArrayConcat([SignPrefix, RPC.Message.encode(_objectSpread(_objectSpread({}, message), {}, {
              from: PeerId.createFromB58String(message.from).toBytes(),
              signature: undefined,
              key: undefined
            })).finish()]); // Get the public key

            _context2.next = 7;
            return messagePublicKey(message);

          case 7:
            pubKey = _context2.sent;
            return _context2.abrupt("return", pubKey.verify(bytes, message.signature));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _verifySignature.apply(this, arguments);
}

function messagePublicKey(_x4) {
  return _messagePublicKey.apply(this, arguments);
}
/**
 * @typedef {import('..').InMessage} InMessage
 * @typedef {import('libp2p-crypto').PublicKey} PublicKey
 */


function _messagePublicKey() {
  _messagePublicKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(message) {
    var from, keyPeerId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (message.from) {
              _context3.next = 2;
              break;
            }

            throw new Error('Could not get the public key from the originator id');

          case 2:
            from = PeerId.createFromB58String(message.from);

            if (!message.key) {
              _context3.next = 12;
              break;
            }

            _context3.next = 6;
            return PeerId.createFromPubKey(message.key);

          case 6:
            keyPeerId = _context3.sent;

            if (!keyPeerId.equals(from)) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return", keyPeerId.pubKey);

          case 9:
            throw new Error('Public Key does not match the originator');

          case 12:
            if (!from.pubKey) {
              _context3.next = 16;
              break;
            }

            return _context3.abrupt("return", from.pubKey);

          case 16:
            throw new Error('Could not get the public key from the originator id');

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _messagePublicKey.apply(this, arguments);
}

module.exports = {
  messagePublicKey: messagePublicKey,
  signMessage: signMessage,
  SignPrefix: SignPrefix,
  verifySignature: verifySignature
};